import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "bg-primary-25 flex flex-col text-left justify-center px-4 text-gray-900 text-base font-medium",
    style: { "height": "52px" }
};
const _hoisted_2 = {
    style: { "height": "498px" },
    class: "overflow-y-scroll flex flex-col space-y-3 py-2"
};
const _hoisted_3 = { class: "flex flex-col px-3 py-2" };
const _hoisted_4 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_5 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_6 = { class: "flex flex-row justify-start space-x-2 px-3 py-2" };
const _hoisted_7 = {
    class: "flex flex-col justify-start space-y-1",
    style: { "width": "85px" }
};
const _hoisted_8 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_9 = {
    class: "flex flex-col justify-start space-y-1",
    style: { "width": "155px" }
};
const _hoisted_10 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_11 = { class: "flex flex-row space-x-1 justify-start items-center" };
const _hoisted_12 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_13 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_14 = { class: "flex flex-row space-x-6 px-3 border border-gray-300 rounded-lg items-center" };
const _hoisted_15 = { class: "text-md font-normal text-gray-400 px-4" };
const _hoisted_16 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_17 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_18 = { class: "flex flex-row space-x-6 px-3 border border-gray-300 rounded-lg items-center" };
const _hoisted_19 = { class: "text-md font-normal text-gray-400 px-4" };
const _hoisted_20 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_21 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_22 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_23 = { class: "w-40 flex items-center" };
import { fonts, fontSize } from '@/compositions/useFontOptions';
import { getHistoryObject } from '@/compositions/useHistoryHelper';
import { useHistoryStore } from '@/store/history';
import { HistoryType } from '@/types/history';
import { Identifiers } from '@/types/identifiers';
import { Alignment } from '@/types/text';
import { Tools } from '@/types/tools';
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PlusIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UIColorPicker, UIInputNumber, UISelect, UISlider, } from '@gohighlevel/ghl-ui';
import Konva from 'konva';
import { computed, inject, onMounted, onUnmounted, ref, watch, } from 'vue';
import EmitterEvent from '@/events';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TextTool',
    props: {
        group: {
            type: Object,
            require: true,
        },
        stage: {
            type: Object,
            require: true,
        },
        selectedOption: {
            type: String,
            require: true,
        },
    },
    setup(__props) {
        const props = __props;
        let textTransformer, textarea, elementControls;
        const historyStore = useHistoryStore();
        const emitter = inject('emitter');
        const lineSpacing = ref(1.0);
        const fontFamily = ref('Arial, sans-serif');
        const textSize = ref('24');
        const colorCode = ref('#000000');
        const backgroundColorCode = ref('#00000000');
        const alignment = ref(Alignment.CENTER);
        const textContent = ref('Double click to edit');
        const textElement = ref([]);
        const activeNodeIndex = ref();
        const beforeObject = ref();
        const afterObject = ref(0);
        const textNode = ref();
        const labelNode = ref();
        const tagNode = ref();
        const colorPickerMode = ref(['hex']);
        const activeTool = computed(() => props.selectedOption);
        watch(activeTool, (newVal, oldVal) => {
            if (activeTool.value === Tools.TEXT) {
                if (!textTransformer) {
                    createTransformer();
                }
                addEventListeners();
            }
            else if (oldVal === Tools.TEXT) {
                hideControls();
                handleOutsideClick();
                textTransformer.detach();
                textTransformer.hide();
                if (labelNode.value) {
                    labelNode.value.off('transform mouseover mouseout dragmove transformend dragstart dragend');
                    textNode.value.off('click dblclick dbltap transform');
                }
                removeEventListeners();
            }
        });
        onMounted(() => {
            emitter.on(EmitterEvent.IMAGE_EDITOR_HISTORY_SET, setTextNode);
            emitter.on(EmitterEvent.IMAGE_EDITOR_CONTROLS_CLONE, cloneElement);
            emitter.on(EmitterEvent.IMAGE_EDITOR_CONTROLS_DELETE, deleteElement);
        });
        onUnmounted(() => {
            handleOutsideClick();
            // remove event listener from all text node
        });
        function cloneElement() {
            if (labelNode.value && props.selectedOption == Tools.TEXT) {
                setBeforeObject(HistoryType.REMOVE);
                activeNodeIndex.value = textElement.value.length;
                const cloneNode = labelNode.value.clone();
                cloneNode.id(`${Identifiers.TEXT_ID_PREFIX}${activeNodeIndex.value}-label`);
                cloneNode
                    .getText()
                    .id(`${Identifiers.TEXT_ID_PREFIX}${activeNodeIndex.value}`);
                cloneNode
                    .getTag()
                    .id(`${Identifiers.TEXT_ID_PREFIX}${activeNodeIndex.value}-tag`);
                cloneNode.setAttrs({
                    x: cloneNode.x() + 20,
                    y: cloneNode.y() + 20,
                });
                props.group.add(cloneNode);
                textElement.value.push(cloneNode);
                setClickEvent(cloneNode, cloneNode.getText());
                setAfterObject(HistoryType.ADD, cloneNode);
                setHistory(HistoryType.ADD, `${Identifiers.TEXT_ID_PREFIX}${activeNodeIndex.value}-label`);
            }
        }
        function deleteElement() {
            if (labelNode.value && props.selectedOption == Tools.TEXT) {
                setBeforeObject(HistoryType.ADD, labelNode.value);
                setAfterObject(HistoryType.REMOVE);
                setHistory(HistoryType.ADD);
                if (textarea)
                    removeTextarea();
                const index = textElement.value.find(text => text.id() === labelNode.value.id());
                if (index !== -1) {
                    textElement.value.splice(index, 1);
                }
                textTransformer.detach();
                labelNode.value.destroy();
                labelNode.value = undefined;
                textNode.value = undefined;
                tagNode.value = undefined;
                elementControls.style.display = 'none';
                elementControls.style.left = '0px';
                elementControls.style.top = '0px';
            }
        }
        function setTextNode(history) {
            if (history && history.source === Tools.TEXT) {
                if (props.selectedOption === Tools.TEXT) {
                    setClickEvent(labelNode.value, textNode.value);
                }
                const elementIndex = textElement.value.findIndex(label => label.id() === history.id);
                labelNode.value = props.group.find(`#${history.id}`)[0];
                textNode.value = labelNode.value.getText();
                tagNode.value = labelNode.value.getTag();
                if (elementIndex !== -1)
                    textElement.value[elementIndex] = labelNode.value;
                else
                    textElement.value.push(labelNode.value);
                if (props.selectedOption === Tools.TEXT) {
                    createTransformer();
                    setActiveNode(textNode.value);
                    setCursor(labelNode.value);
                }
            }
        }
        function removeEventListeners() {
            if (textElement.value.length) {
                textElement.value.forEach(e => {
                    try {
                        e.off('transform mouseover mouseout dragmove transformend dragstart dragend');
                        e.getText().off('click dblclick dbltap transform');
                    }
                    catch (e) {
                        // error
                    }
                });
            }
        }
        function addEventListeners() {
            if (textElement.value.length) {
                labelNode.value = undefined;
                textNode.value = undefined;
                tagNode.value = undefined;
                textElement.value.forEach(e => {
                    if (e && e.getText()) {
                        setClickEvent(e, e.getText());
                        setCursor(e);
                    }
                });
            }
        }
        function setTransformer() {
            if (textElement.value.length) {
                textTransformer.detach();
                if (!labelNode.value)
                    labelNode.value = textElement.value[activeNodeIndex.value];
                textTransformer.nodes([labelNode.value]);
                textTransformer.show();
                textTransformer.forceUpdate();
                setControlPosition();
            }
        }
        function setControlPosition() {
            if (!elementControls)
                elementControls = document.getElementById('ghl-image-editor-element-control');
            elementControls.style.display = 'block';
            // at first lets find position of text node relative to the stage:
            const textPosition = textNode.value.absolutePosition();
            const rotation = labelNode.value.rotation();
            let transform = '';
            if (rotation) {
                transform += 'rotateZ(' + rotation + 'deg)';
            }
            let px = 0;
            // also we need to slightly move textarea on firefox
            // because it jumps a bit
            const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (isFirefox) {
                px += 2 + Math.round(textNode.value.fontSize() / 20);
            }
            transform += 'translateY(-' + px + 'px)';
            const offset = textNode.value.width() * labelNode.value.scaleX() + 25; // Distance from the rectangle center
            const angle = (rotation * Math.PI) / 180; // Convert to radians
            const offsetX = offset * Math.cos(angle);
            const offsetY = offset * Math.sin(angle);
            // so position of textarea will be the sum of positions above:
            const areaPosition = {
                x: props.stage.container().offsetLeft + textPosition.x + offsetX,
                y: props.stage.container().offsetTop + textPosition.y + offsetY,
            };
            elementControls.style.top = areaPosition.y + 'px';
            elementControls.style.left = areaPosition.x + 'px';
            elementControls.style.transform = transform;
            elementControls.style.transformOrigin = 'left top';
        }
        function createTransformer() {
            textTransformer = props.group.find(`#${Identifiers.TEXT_TRANSFORMER}`)[0];
            if (!textTransformer) {
                textTransformer = new Konva.Transformer({
                    enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                    centeredScaling: false,
                    padding: 5,
                    id: Identifiers.TEXT_TRANSFORMER,
                    boundBoxFunc: (oldBox, newBox) => {
                        const box = newBox;
                        const isOut = box.x < 0 ||
                            box.y < 0 ||
                            box.x + box.width > props.stage.width() ||
                            box.y + box.height > props.stage.height();
                        // if new bounding box is out of visible viewport, let's just skip transforming
                        // this logic can be improved by still allow some transforming if we have small available space
                        if (isOut) {
                            return oldBox;
                        }
                        return newBox;
                    },
                });
                props.group.add(textTransformer);
                textTransformer.hide();
            }
        }
        function setClickEvent(label, text) {
            if (label) {
                text.off('dblclick dbltap transform');
                text.on('click', function (e) {
                    setActiveNode(e.target);
                });
                label.draggable(false);
            }
        }
        function setActiveNode(node) {
            if (textNode.value && labelNode.value && textNode.value.id() !== node.id()) {
                setClickEvent(labelNode.value, textNode.value);
            }
            textNode.value = node;
            const labelId = `${node.id()}-label`;
            const tagId = `${node.id()}-tag`;
            labelNode.value = props.stage.find(`#${labelId}`)[0];
            tagNode.value = props.stage.find(`#${tagId}`)[0];
            labelNode.value.draggable(true);
            setTransformer();
            setActiveEvents();
            setDefaultValues();
        }
        function addText() {
            setClickEvent(labelNode.value, textNode.value);
            // Create a text object with the specified properties
            activeNodeIndex.value = textElement.value.length;
            setBeforeObject(HistoryType.REMOVE);
            const centerX = (props.stage.width() - 100) / 2;
            const centerY = (props.stage.height() - 50) / 2;
            labelNode.value = new Konva.Label({
                x: centerX,
                y: centerY,
                draggable: true,
                id: `${Identifiers.TEXT_ID_PREFIX}${activeNodeIndex.value}-label`,
            });
            tagNode.value = new Konva.Tag({
                fill: '#00000000',
                id: `${Identifiers.TEXT_ID_PREFIX}${activeNodeIndex.value}-tag`,
            });
            labelNode.value.add(tagNode.value);
            textNode.value = new Konva.Text({
                text: textContent.value,
                fontSize: 24,
                fill: '#000000',
                fontFamily: 'Arial, sans-serif',
                align: Alignment.CENTER,
                lineHeight: 1.0,
                verticalAlign: 'middle',
                wrap: 'word',
                id: `${Identifiers.TEXT_ID_PREFIX}${activeNodeIndex.value}`,
                padding: 5,
            });
            labelNode.value.add(textNode.value);
            props.group.add(labelNode.value);
            textElement.value.push(labelNode.value);
            const labelX = props.stage.width() / 2 - labelNode.value.width() / 2;
            const labelY = props.stage.height() / 2 - labelNode.value.height() / 2;
            labelNode.value.setAttrs({
                x: labelX,
                y: labelY,
            });
            // props.layer.add(textNode.value)
            setTransformer();
            setActiveEvents();
            setCursor(labelNode.value);
            props.stage.batchDraw();
            setAfterObject(HistoryType.ADD, labelNode.value);
            setHistory(HistoryType.ADD);
            setDefaultValues();
        }
        function setCursor(node) {
            // Set initial cursor
            node.on('mouseover', function () {
                document.body.style.cursor = 'move';
            });
            node.on('mouseout', function () {
                document.body.style.cursor = 'default';
            });
            node.on('dragmove', function () {
                document.body.style.cursor = 'move';
                setControlPosition();
            });
            node.on('transform', function () {
                document.body.style.cursor = 'grabbing';
                setControlPosition();
                // stopTextScaling(e.target)
            });
            node.on('transformstart', function (e) {
                setBeforeObject(HistoryType.UPDATE, e.target);
            });
            node.on('transformend', function (e) {
                document.body.style.cursor = 'move';
                stopTextScaling(e.target);
                setAfterObject(HistoryType.UPDATE, e.target);
                setHistory(HistoryType.UPDATE);
            });
            node.on('dragstart', function (e) {
                setBeforeObject(HistoryType.UPDATE, e.target);
            });
            node.on('dragend', function (e) {
                setAfterObject(HistoryType.UPDATE, e.target);
                setHistory(HistoryType.UPDATE);
            });
        }
        function setActiveEvents() {
            textNode.value.off('click');
            // textNode.value.on('transform', function (e) {
            //   // reset scale, so only with is changing by transformer
            //   e.target.setAttrs({
            //     width: textNode.value.width() * textNode.value.scaleX(),
            //     height: textNode.value.height() * textNode.value.scaleY(),
            //     scaleX: 1,
            //     scaleY: 1,
            //   })
            // })
            textNode.value.on('dblclick dbltap', e => {
                // hide text node and transformer:
                e.target.hide();
                // tr.hide()
                addTextArea();
            });
        }
        function removeTextarea() {
            try {
                if (!textarea)
                    return;
                const id = textarea.id;
                const text = textarea.value;
                textarea.parentNode.removeChild(textarea);
                textarea = undefined;
                window.removeEventListener('click', handleOutsideClick);
                if (textNode.value) {
                    let node = textNode.value;
                    if (id !== textNode.value.id()) {
                        node = props.stage.find(`#${id}`)[0];
                        node.text(text);
                    }
                    node.show();
                    node.draggable(false);
                    textTransformer.show();
                    textTransformer.forceUpdate();
                }
            }
            finally {
                historyStore.setDisableSaving(false);
            }
        }
        function setTextareaWidth(newWidth) {
            if (!newWidth) {
                // set width for placeholder
                newWidth = textNode.value.placeholder.length * textNode.value.fontSize();
            }
            // some extra fixes on different browsers
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (isSafari || isFirefox) {
                newWidth = Math.ceil(newWidth);
            }
            const isEdge = document.documentMode || /Edge/.test(navigator.userAgent);
            if (isEdge) {
                newWidth += 1;
            }
            textarea.style.width = newWidth + 'px';
        }
        function handleOutsideClick(e) {
            if ((e && e.target !== textarea) || !e) {
                if (textarea) {
                    const id = textarea.id;
                    const text = textarea.value;
                    const newWidth = parseInt(textarea.style.width.replace('px', ''));
                    const newHeight = parseInt(textarea.style.height.replace('px', ''));
                    removeTextarea();
                    if (textNode.value && id === textNode.value.id()) {
                        if (!text.length) {
                            setBeforeObject(HistoryType.ADD, labelNode.value);
                            setAfterObject(HistoryType.REMOVE);
                            setHistory(HistoryType.ADD);
                            const index = textElement.value.find(text => text.id() === labelNode.value.id());
                            if (index !== -1) {
                                textElement.value.splice(index, 1);
                            }
                            labelNode.value.destroy();
                            textTransformer.detach();
                            textTransformer.hide();
                            hideControls();
                        }
                        else {
                            setBeforeObject(HistoryType.UPDATE, labelNode.value);
                            if (text.length > textNode.value.text().length) {
                                textNode.value.width(newWidth);
                                textNode.value.height(newHeight);
                                labelNode.value.width(newWidth);
                                labelNode.value.height(newHeight);
                            }
                            textNode.value.text(text);
                            textTransformer.forceUpdate();
                            setAfterObject(HistoryType.UPDATE, labelNode.value);
                            setHistory(HistoryType.UPDATE);
                            setControlPosition();
                            // setClickEvent(labelNode.value, textNode.value)
                        }
                        if (!e) {
                            textTransformer.detach();
                            labelNode.value = undefined;
                            textNode.value = undefined;
                            tagNode.value = undefined;
                            setToDefault();
                        }
                    }
                }
            }
        }
        function addTextArea() {
            hideControls();
            // create textarea and style it
            textarea = document.createElement('textarea');
            document.getElementById('ghl-image-editor-container').appendChild(textarea);
            // apply many styles to match text on canvas as close as possible
            // remember that text rendering on canvas and on the textarea can be different
            // and sometimes it is hard to make it 100% the same. But we will try...
            // at first lets find position of text node relative to the stage:
            const textPosition = textNode.value.absolutePosition();
            // so position of textarea will be the sum of positions above:
            const areaPosition = {
                x: props.stage.container().offsetLeft + textPosition.x,
                y: props.stage.container().offsetTop + textPosition.y,
            };
            textarea.value = textNode.value.text();
            textarea.style.position = 'absolute';
            textarea.style.top = areaPosition.y + 34 + 'px';
            textarea.style.left = areaPosition.x - 3 + 'px';
            textarea.style.width = textTransformer.width() + 5 + 'px';
            textarea.style.height = textTransformer.height() + 14 + 'px';
            textarea.style.fontSize = textNode.value.fontSize() + 'px';
            textarea.style.border = 'none';
            textarea.style.padding = '0px';
            textarea.style.paddingTop = '5px';
            textarea.style.paddingBottom = '5px';
            textarea.style.margin = '0px';
            textarea.style.overflow = 'hidden';
            textarea.style.background = 'transparent';
            textarea.style.outline = 'none';
            textarea.style.resize = 'none';
            textarea.style.lineHeight = textNode.value.lineHeight();
            textarea.style.fontFamily = textNode.value.fontFamily();
            textarea.style.transformOrigin = 'left top';
            textarea.style.textAlign = textNode.value.align();
            textarea.style.color = textNode.value.fill();
            textarea.classList.add('focus:ring-0');
            textarea.setAttribute('id', textNode.value.id());
            const rotation = labelNode.value.rotation();
            let transform = '';
            if (rotation) {
                transform += 'rotateZ(' + rotation + 'deg)';
            }
            let px = 0;
            // also we need to slightly move textarea on firefox
            // because it jumps a bit
            const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (isFirefox) {
                px += 2 + Math.round(textNode.value.fontSize() / 20);
            }
            transform += 'translateY(-' + px + 'px)';
            textarea.style.transform = transform;
            // reset height
            textarea.style.zIndex = 20;
            // after browsers resized it we can set actual value
            // textarea.style.height = textarea.scrollHeight + 3 + 'px'
            textarea.focus();
            textarea.addEventListener('keydown', function (e) {
                // hide on enter
                // but don't hide on shift + enter
                // if (e.keyCode === 13 && !e.shiftKey) {
                //   setBeforeObject(HistoryType.UPDATE, textNode.value)
                //   textNode.value.text(textarea.value)
                //   setAfterObject(HistoryType.UPDATE, textNode.value)
                //   setHistory(HistoryType.UPDATE)
                //   removeTextarea()
                // }
                // on esc do not set value back to node
                if (e.keyCode === 27) {
                    removeTextarea();
                }
            });
            textarea.addEventListener('keydown', function () {
                const scale = textNode.value.getAbsoluteScale().x;
                setTextareaWidth(textNode.value.width() * scale);
                textarea.style.height = 'auto';
                textarea.style.height =
                    textarea.scrollHeight + textNode.value.fontSize() + 'px';
            });
            setTimeout(() => {
                window.addEventListener('click', handleOutsideClick);
            });
            historyStore.setDisableSaving(true);
        }
        function setDefaultValues() {
            const fontSize = Math.round(textNode.value.fontSize() * Math.abs(labelNode.value.scaleX()));
            textSize.value = fontSize.toString();
            lineSpacing.value = textNode.value.lineHeight();
            colorCode.value = textNode.value.fill();
            alignment.value = textNode.value.align();
            fontFamily.value = textNode.value.fontFamily();
            backgroundColorCode.value = tagNode.value.fill() || '#0000000';
        }
        function handleColorChange(color) {
            colorCode.value = color;
            if (textNode.value && textNode.value.fill() !== color) {
                setBeforeObject(HistoryType.UPDATE, labelNode.value);
                textNode.value.fill(colorCode.value);
                setAfterObject(HistoryType.UPDATE, labelNode.value);
                setHistory(HistoryType.UPDATE);
            }
        }
        function handleBackgroundChange(color) {
            backgroundColorCode.value = color;
            if (tagNode.value && tagNode.value.fill() !== color) {
                setBeforeObject(HistoryType.UPDATE, labelNode.value);
                tagNode.value.fill(backgroundColorCode.value);
                setAfterObject(HistoryType.UPDATE, labelNode.value);
                setHistory(HistoryType.UPDATE);
            }
        }
        function setAlignment(type) {
            alignment.value = type;
            if (textNode.value) {
                setBeforeObject(HistoryType.UPDATE, labelNode.value);
                textNode.value.align(alignment.value);
                textTransformer.detach(labelNode.value);
                textTransformer.nodes([labelNode.value]);
                setAfterObject(HistoryType.UPDATE, labelNode.value);
                setHistory(HistoryType.UPDATE);
                setControlPosition();
            }
        }
        function setFontFamily(value) {
            fontFamily.value = value;
            if (textNode.value) {
                setBeforeObject(HistoryType.UPDATE, labelNode.value);
                textNode.value.fontFamily(fontFamily.value);
                textTransformer.detach(labelNode.value);
                textTransformer.nodes([labelNode.value]);
                setAfterObject(HistoryType.UPDATE, labelNode.value);
                setHistory(HistoryType.UPDATE);
                setControlPosition();
            }
        }
        function lineSpacingChange() {
            // update line space for selected text option
            if (textNode.value) {
                setBeforeObject(HistoryType.UPDATE, labelNode.value);
                textNode.value.lineHeight(lineSpacing.value);
                textTransformer.detach(labelNode.value);
                textTransformer.nodes([labelNode.value]);
                setAfterObject(HistoryType.UPDATE, labelNode.value);
                setHistory(HistoryType.UPDATE);
                setControlPosition();
            }
        }
        function setFontSize() {
            if (textNode.value) {
                setBeforeObject(HistoryType.UPDATE, labelNode.value);
                textNode.value.fontSize(parseInt(textSize.value));
                textTransformer.detach(labelNode.value);
                textTransformer.nodes([labelNode.value]);
                setAfterObject(HistoryType.UPDATE, labelNode.value);
                setHistory(HistoryType.UPDATE);
                setControlPosition();
            }
        }
        function setToDefault() {
            textSize.value = '24';
            lineSpacing.value = 1.0;
            fontFamily.value = 'Arial, sans-serif';
            colorCode.value = '#000000';
            backgroundColorCode.value = '#00000000';
            alignment.value = Alignment.CENTER;
        }
        function setBeforeObject(type, node) {
            beforeObject.value = getHistoryObject(Tools.TEXT, node, type);
        }
        function setAfterObject(type, node) {
            afterObject.value = getHistoryObject(Tools.TEXT, node, type);
        }
        function setHistory(type, id) {
            if (!id)
                id = labelNode.value.id();
            historyStore.setHistory(id, Tools.TEXT, beforeObject.value, afterObject.value, type);
        }
        function hideControls() {
            if (elementControls)
                elementControls.style.display = 'none';
        }
        function stopTextScaling(node) {
            try {
                const scaleX = node.scaleX();
                const newFontSize = Math.round(textNode.value.fontSize() * Math.abs(scaleX));
                // Apply the new font size to the text node
                textSize.value = newFontSize.toString();
            }
            catch (error) {
                // do nothing
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('text.title')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            class: "cursor-pointer py-2 px-2 space-x-2 items-center justify-center flex flex-row bg-blue-50 rounded-lg text-blue-700 text-sm font-semibold",
                            onClick: addText
                        }, [
                            _createVNode(_unref(PlusIcon), { class: "w-3 h-3" }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.addText')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('text.fontFamily')), 1),
                        _createVNode(_unref(UISelect), {
                            id: "media-editor-font-family",
                            value: fontFamily.value,
                            "onUpdate:value": [
                                _cache[0] || (_cache[0] = ($event) => ((fontFamily).value = $event)),
                                setFontFamily
                            ],
                            options: _unref(fonts),
                            placeholder: "Select font",
                            style: { "width": "248px" },
                            disabled: !textNode.value
                        }, null, 8, ["value", "options", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('text.fontSize')), 1),
                            _createVNode(_unref(UISelect), {
                                id: "media-editor-font-size",
                                value: textSize.value,
                                "onUpdate:value": [
                                    _cache[1] || (_cache[1] = ($event) => ((textSize).value = $event)),
                                    setFontSize
                                ],
                                options: _unref(fontSize),
                                disabled: !textNode.value
                            }, null, 8, ["value", "options", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('text.textAlignment')), 1),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_unref(UIButton), {
                                    id: "media-editor-font-left-align-btn",
                                    type: alignment.value === _unref(Alignment).LEFT ? 'tertiary' : 'default',
                                    onClick: _cache[2] || (_cache[2] = ($event) => (setAlignment(_unref(Alignment).LEFT))),
                                    disabled: !textNode.value
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(AlignLeftIcon), { class: "w-5 h-5 text-gray-900" })
                                    ]),
                                    _: 1
                                }, 8, ["type", "disabled"]),
                                _createVNode(_unref(UIButton), {
                                    id: "media-editor-font-center-align-btn",
                                    type: alignment.value === _unref(Alignment).CENTER ? 'tertiary' : 'default',
                                    onClick: _cache[3] || (_cache[3] = ($event) => (setAlignment(_unref(Alignment).CENTER))),
                                    disabled: !textNode.value
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(AlignCenterIcon), { class: "w-5 h-5 text-gray-900" })
                                    ]),
                                    _: 1
                                }, 8, ["type", "disabled"]),
                                _createVNode(_unref(UIButton), {
                                    id: "media-editor-font-right-align-btn",
                                    type: alignment.value === _unref(Alignment).RIGHT ? 'tertiary' : 'default',
                                    onClick: _cache[4] || (_cache[4] = ($event) => (setAlignment(_unref(Alignment).RIGHT))),
                                    disabled: !textNode.value
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(AlignRightIcon), { class: "w-5 h-5 text-gray-900" })
                                    ]),
                                    _: 1
                                }, 8, ["type", "disabled"])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('text.fontColor')), 1),
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_unref(UIColorPicker), {
                                compact: true,
                                defaultShow: false,
                                enableAlpha: true,
                                modes: colorPickerMode.value,
                                defaultValue: colorCode.value,
                                value: colorCode.value,
                                "onUpdate:value": [
                                    _cache[5] || (_cache[5] = ($event) => ((colorCode).value = $event)),
                                    handleColorChange
                                ],
                                disabled: !textNode.value
                            }, null, 8, ["modes", "defaultValue", "value", "disabled"]),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(colorCode.value), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('text.backgroundColor')), 1),
                        _createElementVNode("div", _hoisted_18, [
                            _createVNode(_unref(UIColorPicker), {
                                compact: true,
                                defaultShow: false,
                                enableAlpha: true,
                                modes: colorPickerMode.value,
                                defaultValue: backgroundColorCode.value,
                                value: backgroundColorCode.value,
                                "onUpdate:value": [
                                    _cache[6] || (_cache[6] = ($event) => ((backgroundColorCode).value = $event)),
                                    handleBackgroundChange
                                ],
                                disabled: !textNode.value
                            }, null, 8, ["modes", "defaultValue", "value", "disabled"]),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(backgroundColorCode.value), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('text.lineSpacing')), 1),
                        _createElementVNode("div", _hoisted_22, [
                            _createVNode(_unref(UIInputNumber), {
                                id: "media-editor-text-line-height-input",
                                size: "medium",
                                value: lineSpacing.value,
                                "onUpdate:value": _cache[7] || (_cache[7] = ($event) => ((lineSpacing).value = $event)),
                                style: { "width": "58px" },
                                min: 0.5,
                                max: 3.0,
                                showButton: false,
                                placeholder: "",
                                disabled: !textNode.value,
                                "onUpdate:modelValue": lineSpacingChange
                            }, null, 8, ["value", "min", "max", "disabled"]),
                            _createElementVNode("div", _hoisted_23, [
                                _createVNode(_unref(UISlider), {
                                    value: lineSpacing.value,
                                    "onUpdate:value": [
                                        _cache[8] || (_cache[8] = ($event) => ((lineSpacing).value = $event)),
                                        lineSpacingChange
                                    ],
                                    step: 0.1,
                                    tooltip: false,
                                    min: 0.5,
                                    max: 3.0,
                                    disabled: !textNode.value
                                }, null, 8, ["value", "step", "min", "max", "disabled"])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
